module.exports = __webpack_public_path__ + "img/step-4.afe57519.jpg";